const partnersSection = $('#partners-section');
const partnersLogosParent = partnersSection.find('.partners-logos-parent');
const partnersLogosList = partnersSection.find('.partners-logos-list');
partnersLogosParent.append(partnersLogosList.clone());
const partnersLogos = partnersSection.find('.partner-logo');

/*
const aspectSize = isDesktop() ? 16 : isTablet() ? 10 : 3.6;

const setLogosSize = () => {
  partnersLogos.each(function () {
    const logoWidth = $(this).width();
    const aspect = isDesktop() ? 16 : 3.6;
    console.log(logoWidth);
    $(this).css('width', `${logoWidth / aspect}vw`);
  });
};

setLogosSize();
*/

const partnersLogosLoop = () => {
  const logoParentWidth = pxToVw(partnersLogosList.eq(0).outerWidth()) + 4.375;
  const loopTL = gsap.timeline({ paused: true, repeat: -1 });
  loopTL.add(
    gsap.fromTo(
      partnersLogosParent,
      {
        x: 0,
      },
      {
        x: `-${logoParentWidth}vw`,
        duration: 15,
        ease: 'linear',
      }
    )
  );
  loopTL.play();
};

const partnersLogosAnimationIn = () => {
  logosInTL = gsap.timeline({
    paused: true,
    onComplete: () => {},
  });

  logosInTL.add(
    gsap.fromTo(
      partnersLogos,
      {
        opacity: 0,
        x: '25vw',
      },
      {
        opacity: 1,
        x: 0,
        duration: 1,
        stagger: {
          each: 0.07,
        },
      }
    )
  );

  return logosInTL;
};

const partnerInAnimation = () => {
  const parntersTL = gsap.timeline({ paused: true });
  const animationInConfig = {
    title: {
      offsetPercent: 200,
      opacityStart: 0,
      blurStart: '0px',
      duration: 1.2,
      delay: 0.3,
      stagger: 0.1,
      isDurationCommon: true,
    },
    descriptor: {
      offsetPercent: 36.6,
      duration: 1,
    },
  };

  parntersTL.add(
    animateSectionTopperIn({
      sectionParent: partnersSection,
      titleStagger: 0.3,
      animationInConfig: animationInConfig,
    }).play(),
    0
  );
  parntersTL.add(partnersLogosAnimationIn().play(0), 0.8);

  return parntersTL;
};

const initPartners = () => {
  if (!isDesktop() && !isTablet()) {
    joinDoubleTitle(partnersSection);
  }

  if(!isDesktop()){
    partnersLogosLoop();
  } else {
    const parntersTL = partnerInAnimation();
    ScrollTrigger.create({
      trigger: partnersSection,
      start: 'top top+=80%',
      end: 'bottom bottom',
      once: true,
      onEnter: () => {
        partnersLogosLoop();
        parntersTL.play();
      },
    });
  }

}

/*
$(window).on('load', () => {
  initPartners()
});
*/

addSectionObserver(partnersSection, initPartners);
